module.exports = __webpack_public_path__ + "img/espa-en-alt.9af1d74b.jpg";